export const origin = () => window.location.origin;
export const href = () => window.location.href;
export const pathname = () => window.location.pathname;
